import { useQuery } from '@tanstack/react-query';
import { IEmploymentContract } from '../../Interfaces/IEmploymentContract';
import { customFetcher } from '../useFetch';

export const useGetEmploymentContracts = () => {
  const { data: employmentContracts, isLoading: isLoadingEmploymentContracts } =
    useQuery<IEmploymentContract[]>({
      queryKey: ['employmentcontract'],
      queryFn: () => customFetcher({ endpoint: '/employmentcontract' }),
    });

  return { employmentContracts, isLoadingEmploymentContracts };
};
